export enum RequiredWidth {
  W150 = 150,
  W240 = 240,
  W320 = 320,
  W480 = 480,
  W640 = 640,
  W750 = 750, // recommended
  W1080 = 1080,
  W2160 = 2160,
  Uncompressed = -1,
}

export enum RequiredQuality {
  Q100 = 100,
  Q95 = 95,
  Q90 = 90,
  Q80 = 80, // recommended
  Q60 = 60,
  Q40 = 40,
}

export enum RequiredResizingType {
  // 가로 세로 비율 유지, 이미지 맞게 자르거나 클리핑
  // (recommended) Preserving aspect ratio, ensure the image covers both provided dimensions by cropping/clipping to fit.
  Cover = 'cover',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Crop = 'cover',
  // 가로 세로 비율 유지, 레터박스라도 사용해서 원본 유지
  // Preserving aspect ratio, contain within both provided dimensions using "letterboxing" where necessary.
  Contain = 'contain',
  // 종횡비 무시, 비율 맞추려고 늘림
  // Ignore the aspect ratio of the input and stretch to both provided dimensions.
  Fill = 'fill',
  // 가로 세로 비율 유지, width / height 비율을 유지하면서 치수에 맞춰 최대로 이미지를 만듦
  // Preserving aspect ratio, resize the image to be as large as possible while ensuring its dimensions are less than or equal to both those specified.
  Outside = 'outside',
  // 가로 세로 비율 유지, width / height 비율을 유지하면서 치수에 맞춰 최소로 이미지를 만듦
  // Preserving aspect ratio, resize the image to be as small as possible while ensuring its dimensions are greater than or equal to both those specified.
  Inside = 'inside',
}

export interface ResourceUriDecoratorOptions {
  width?: RequiredWidth
  quality?: RequiredQuality
  resizingType?: RequiredResizingType
}

export const resourceUriDecorate = (source: string, options?: ResourceUriDecoratorOptions) => {
  if (options === undefined) {
    return source
  }

  const w = options.width ?? RequiredWidth.W750
  const q = options.quality ?? RequiredQuality.Q90
  const t = options.resizingType ?? RequiredResizingType.Cover

  return `${source}?w=${w}&q=${q}&t=${t}`
}

export default resourceUriDecorate
